import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useMeteringRecords} from '../hooks/useMeteringRecords.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useMeteringRecords();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
